import { useTranslation, withTranslation } from "react-i18next"
import { TableContainer, Table, TableRow, TableHead, TableCell, TableBody } from '@mui/material/';
import React from "react";
import '../../utils/common.scss';
import SETTINGS from './../../utils/constants';

const PriceTable=()=>{
    const {t} = useTranslation();
    const translateArray = t('priceInfo', {returnObjects: true})

    return(
        <TableContainer>
            <Table size='medium' sx={{tableLayout: 'fixed'}}>
                <TableHead>
                    <TableRow>
                        {translateArray?.tableHead?.map((item, index)=>{
                            return <TableCell key={index} sx={{fontSize: {xs:'16px', md: '32px'}, fontWeight: 700, lineHeight: '48px', color: SETTINGS.DEEP_COLOR, width: index===0? '55%': '45%'}}>{item}</TableCell>
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {translateArray?.groups?.map((group)=>{
                        return(
                            <React.Fragment key={group.id}>
                                {group.title?
                                    <TableRow>
                                        <TableCell colSpan={translateArray.tableHead.length} sx={{fontSize: {xs:'18px', md: '24px'}, fontWeight: 700, color: SETTINGS.DEEP_COLOR, borderBottom: 'none', paddingTop: '30px'}}>
                                            {group.title}
                                        </TableCell>
                                    </TableRow>
                                    :
                                    null
                                }
                                {group.tableBody.map((item)=>{
                                    return(
                                        <TableRow key={item.id}>
                                            <TableCell sx={{fontSize:{xs:'16px', md: '20px'}, fontWeight: 450, color: SETTINGS.SECONDARY_COLOR}}>
                                                {item.name}
                                            </TableCell>
                                            <TableCell sx={{fontSize:{xs:'16px', md: '20px'}, fontWeight: 450, color: SETTINGS.SECONDARY_COLOR, whiteSpace: 'pre-line'}}>
                                                {item.price}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </React.Fragment>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default withTranslation()(PriceTable)
